<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-02-20 08:54:41
 * @LastEditTime: 2024-02-29 18:56:34
 * @Description:
 * @FilePath: \website\src\pages\quotation\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-carousel class="swiper" height="464px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img width="100%" :src="item" alt="" />
            </el-carousel-item>
        </el-carousel>
        <SubMenu
            class="submenu"
            :menuList="menuList"
            @anchorTo="$anchorTo"
        ></SubMenu>
        <!-- 生产区行情 -->
        <div class="production" id="quo1">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/production-topic-quotation.png"
            ></Topic>
            <div class="list">
                <div
                    class="list-item"
                    v-for="(item, index) in productionList"
                    :key="index"
                >
                    <div class="left">
                        <div class="area">{{ item.area_name }}</div>
                        <div
                            class="state"
                            :style="{
                                color: [
                                    '行情偏强',
                                    '行情平稳',
                                    '行情稳弱',
                                ].includes(item.sub_title)
                                    ? '#E11F1F'
                                    : '',
                            }"
                        >
                            {{ item.sub_title }}
                        </div>
                    </div>
                    <div class="main" v-html="item.content"></div>
                </div>
            </div>
        </div>
        <!-- 销区价格 -->
        <div class="sales" id="quo2">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/sales-topic-quotation.png"
            ></Topic>
            <el-table
                :data="tableData"
                style="width: 100%"
                :header-cell-style="{ background: '#E3E9E6' }"
                :row-style="{ background: '#F5F5F5' }"
            >
                <el-table-column
                    prop="area_name"
                    label="市场名称"
                    width="550"
                ></el-table-column>
                <el-table-column
                    prop="price_unit"
                    label="单位"
                    width="125"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="today_price"
                    label="今日"
                    width="125"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="yesterday_price"
                    label="昨日"
                    width="125"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="adr"
                    label="涨跌"
                    width="125"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{
                            typeof scope.row.adr == "number"
                                ? scope.row.adr + "%"
                                : "-"
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="week" label="近一周" align="center">
                    <template slot-scope="scope">
                        <el-popover
                            placement="left"
                            width="600"
                            trigger="click"
                        >
                            <div
                                :id="`eChart-${scope.row.area_id}`"
                                :style="{ width: '588px', height: '238px' }"
                                v-loading="marketLoading"
                            ></div>
                            <i
                                class="el-icon-data-line"
                                @click="getWeekPrice(scope.row.area_id)"
                                slot="reference"
                            ></i>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :page-size="tablePageSize"
                :total="tableDataTotal"
                @current-change="
                    (e) => {
                        tablePageNum = e;
                    }
                "
                @prev-click="
                    (e) => {
                        tablePageNum = e;
                    }
                "
                @next-click="
                    (e) => {
                        tablePageNum = e;
                    }
                "
            ></el-pagination>
        </div>
        <!-- 行情周报 -->
        <div class="report" id="quo3">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/report-topic-quotation.png"
            ></Topic>
            <el-row :gutter="40">
                <el-col
                    :span="8"
                    v-for="(item, index) in reportList"
                    :key="index"
                >
                    <div
                        @click="$router.push({ name: 'content', params: item })"
                    >
                        <el-image :src="item.cover" fit="cover"></el-image>
                        <div class="text">
                            <div class="name">{{ item.title }}</div>
                            <div class="month">{{ item.subTitle }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 数据可视 -->
        <div class="data" id="quo4">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/data-topic-quotation.png"
            ></Topic>
            <el-row :gutter="32">
                <el-col :span="12">
                    <div class="title">今日均价</div>
                    <el-row :gutter="12">
                        <el-col
                            :span="8"
                            v-for="(item, index) in visualizations"
                            :key="index"
                        >
                            <el-row
                                class="price-tag"
                                type="flex"
                                align="middle"
                            >
                                <el-col :span="14">
                                    <div class="province">
                                        {{ item.area_name }}
                                    </div>
                                    <div class="price">
                                        {{ item.avg_price.toFixed(2) }}元/公斤
                                    </div>
                                </el-col>
                                <el-col :span="10" style="text-align: right">
                                    <img
                                        width="40"
                                        src="http://wwwadm.tudouec.com/profile/resource/www_img/icon-money.png"
                                        alt=""
                                    />
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-pagination
                        background
                        hide-on-single-page
                        layout="prev, next"
                        :page-size="pageSize"
                        :total="visualizationsTotal"
                        @prev-click="
                            (e) => {
                                pageNum = e;
                            }
                        "
                        @next-click="
                            (e) => {
                                pageNum = e;
                            }
                        "
                    ></el-pagination>
                </el-col>
                <el-col :span="12">
                    <div class="filter">
                        <div class="title">价格走势</div>
                        <el-select
                            v-model="queryChart.areaId"
                            placeholder="请选择"
                            size="mini"
                            ><el-option key="" label="全国" value="">
                            </el-option>
                            <el-option
                                v-for="item in areaOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>

                    <div
                        id="eChart"
                        :style="{ width: '588px', height: '238px' }"
                    ></div>
                    <div class="granularity">
                        <div class="tab-date">
                            <div
                                :class="{ active: curType == 'year' }"
                                @click="changeQuery('year', 'cur')"
                            >
                                年度
                            </div>
                            <div
                                :class="{ active: curType == 'mouth' }"
                                @click="changeQuery('mouth', 'cur')"
                            >
                                月度
                            </div>
                        </div>
                        <div class="tab-date" v-if="curType == 'mouth'">
                            <div
                                :class="{ active: curDate == 'prev' }"
                                @click="changeQuery(curType, 'prev')"
                            >
                                上月
                            </div>
                            <div
                                :class="{ active: curDate == 'cur' }"
                                @click="changeQuery(curType, 'cur')"
                            >
                                本月
                            </div>
                        </div>
                        <div class="tab-date" v-if="curType == 'year'">
                            <div
                                :class="{ active: curDate == 'prev' }"
                                @click="changeQuery(curType, 'prev')"
                            >
                                去年
                            </div>
                            <div
                                :class="{ active: curDate == 'cur' }"
                                @click="changeQuery(curType, 'cur')"
                            >
                                今年
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { formatTime } from "../../assets/js/utils";
export default {
    data() {
        return {
            bannerList: ["http://wwwadm.tudouec.com/profile/resource/www_img/banner-quotation.png"],
            menuList: [
                { name: "主产区行情", anchorId: "quo1" },
                { name: "销区价格", anchorId: "quo2" },
                { name: "行情周报", anchorId: "quo3" },
                { name: "数据可视", anchorId: "quo4" },
            ],
            productionList: [],
            tableData: [],
            tableDataTotal: 0,
            tablePageSize: 10,
            tablePageNum: 1,
            marketLoading: false,
            reportList: [],
            visualizations: null,
            visualizationsTotal: 0,
            pageNum: 1,
            pageSize: 6,
            areaOptions: [],
            chartOption: {
                color: ["#686B82"],
                xAxis: {
                    type: "category",
                    axisLine: {
                        lineStyle: {
                            color: "#686B82",
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#686B82",
                        },
                    },
                    data: [],
                },
                yAxis: {
                    color: "##686B82",
                    name: "单位：元",
                    axisLine: {
                        lineStyle: {
                            color: "#686B82",
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#686B82",
                        },
                    },
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    showContent: true, // 是否显示提示框浮层，默认显示
                    alwaysShowContent: true, // 是否永远显示提示框内容，默认情况下在移出可触发提示框区域后一定时间后隐藏
                    triggerOn: "mousemove|click", // 提示框触发的条件（'mousemove'，鼠标移动时触发；'click'，鼠标点击时触发；'mousemove|click'，同时鼠标移动和点击时触发；'none'，不在 'mousemove' 或 'click' 时触发）
                    confine: true, // 是否将 tooltip 框限制在图表的区域内
                    backgroundColor: "rgba(50,50,50,0.7)", // 提示框浮层的背景颜色
                    padding: 5, // 提示框浮层内边距，单位px
                    textStyle: {
                        color: "#FFF", // 文字的颜色
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "16", // 文字字体大小
                    },
                    formatter: function (params) {
                        var result = "";
                        result +=
                            params[0].axisValue +
                            "</br>" +
                            "最高价:" +
                            (params[1].data + params[0].data).toFixed(2) +
                            "</br>" +
                            "平均价:" +
                            params[2].data.toFixed(2) +
                            "</br>" +
                            "最低价:" +
                            params[0].value.toFixed(2);
                        return result;
                    },
                },
                series: [
                    {
                        name: "L",
                        type: "line",
                        data: [],
                        lineStyle: {
                            opacity: 0.5,
                            color: "#019845",
                        },
                        stack: "confidence-band",
                        symbol: "none",
                    },
                    {
                        name: "U",
                        type: "line",
                        data: [],
                        lineStyle: {
                            opacity: 0.5,
                            color: "#019845",
                        },
                        areaStyle: {
                            color: "#01984550",
                        },
                        stack: "confidence-band",
                        symbol: "none",
                    },
                    {
                        type: "line",
                        data: [],
                        itemStyle: {
                            color: "#019845",
                        },
                    },
                ],
            },
            chart: null,
            queryChart: {
                areaId: null,
                year: new Date().getFullYear(),
                mouth: new Date().getMonth() + 1,
            },
            curType: "mouth",
            curDate: "cur",
        };
    },
    mounted() {
        // this.getPriceFromApi();
        this.getProductionNews();
        this.getMarketPrice();
        this.getPriceDataView();
        this.getNewsList("report");
        this.getRootArea();
        this.queryChart.areaId = "";
        this.chart = echarts.init(document.getElementById("eChart"));
    },
    watch: {
        queryChart: {
            handler: function () {
                this.getPriceTendency();
            },
            deep: true,
        },
        tablePageNum() {
            // this.getPriceFromApi();
            this.getMarketPrice();
        },
        pageNum() {
            this.getPriceDataView();
        },
    },
    methods: {
        // getPriceFromApi(province = "", city = "") {
        //     const that = this;
        //     let today = formatTime(new Date());
        //     let params = {
        //         typeId: 4,
        //         page: that.tablePageNum,
        //         province,
        //         city,
        //         date: today,
        //     };
        //     this.$api.getPriceFromApi(params).then((res) => {
        //         // console.log(res);
        //         that.tableData = res.content;
        //         that.tableDataTotal = res.totalElements;
        //     });
        // },
        getProductionNews() {
            const that = this;
            that.$api.getProductionNews().then((res) => {
                if (res.code != 0) return;
                that.productionList = res.data;
            });
        },
        getMarketPrice() {
            const that = this;
            let req = {
                pageSize: that.tablePageSize,
                pageNum: that.tablePageNum,
            };
            that.$api.getMarketPrice(req).then((res) => {
                if (res.code != 0) return;
                // console.log(res);
                that.tableData = res.rows;
                that.tableDataTotal = res.total;
            });
        },
        // 市场一周价格走势
        getWeekPrice(id) {
            const that = this;
            let query = {
                areaId: id,
            };
            that.$api.getWeekPrice(query).then((res) => {
                let options = {
                    color: ["#FCB015"],
                    xAxis: {
                        type: "category",
                        data: [],
                    },
                    yAxis: {
                        min: 0,
                        max: 5,
                        splitNumber: 5,
                        color: "#FFFFFF",
                        name: "单位：元",
                    },
                    series: [
                        {
                            data: [],
                            type: "line",
                            smooth: true,
                            label: {
                                show: true,
                            },
                        },
                    ],
                };
                res.reverse().map((item, index) => {
                    options.xAxis.data.push(item.price_date);
                    options.series[0].data.push(item.price_value);
                });
                const chart = echarts.init(
                    document.getElementById(`eChart-${id}`)
                );
                chart.setOption(options);
            });
        },

        // 市场一周价格走势
        // async getWeekPrice(data) {
        //     const that = this;
        //     that.marketLoading = true
        //     let timestemp = new Date(data.releasetime).getTime();
        //     let query = {
        //         typeId: 4,
        //         province: data.province,
        //         city: data.city,
        //         date: formatTime(new Date(timestemp)),
        //     };
        //     function getData(req) {
        //         return that.$api.getPriceFromApi(req);
        //     }
        //     let options = [];
        //     for (let i = 1; i <= 7; i++) {
        //         query.date = formatTime(
        //             new Date(timestemp) - i * 24 * 60 * 60 * 1000
        //         );
        //         await getData(query).then((res) => {
        //             options.push(
        //                 res.content.find((item) => item.market == data.market)
        //             );
        //         });
        //     }
        //     let chartOptions = {
        //         color: ["#FCB015"],
        //         xAxis: {
        //             type: "category",
        //             data: [],
        //         },
        //         yAxis: {
        //             color: "#FFFFFF",
        //             name: "单位：元",
        //         },
        //         series: [
        //             {
        //                 data: [],
        //                 type: "line",
        //                 smooth: true,
        //             },
        //         ],
        //     };
        //     options.map((item, index) => {
        //         chartOptions.xAxis.data.push(item.releasetime);
        //         chartOptions.series[0].data.push(item.price);
        //     });
        //     const chart = echarts.init(
        //         document.getElementById(`eChart-${data.market}`)
        //     );
        //     chart.setOption(chartOptions);
        //     that.marketLoading = false
        // },

        // 获取可视数据
        getPriceDataView() {
            const that = this;
            let req = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            that.$api.getPriceDataView(req).then((res) => {
                that.visualizations = res.rows;
                that.visualizationsTotal = res.total;
            });
        },
        getNewsList(type) {
            let that = this;
            let reqData = {
                type: type,
            };
            that.$api.getNewsList(reqData).then((res) => {
                that.reportList = res.rows;
            });
        },
        // 查询价格走势区域
        getRootArea() {
            let that = this;
            that.$api.getRootArea().then((res) => {
                that.areaOptions = res.data;
                // that.queryChart.areaId = res.data[0].id;
            });
        },
        // 获取价格走势图表数据
        getPriceTendency() {
            let that = this;
            let req = that.queryChart;
            that.chartOption = that.$options.data().chartOption;
            that.$api.getPriceTendency(req).then((res) => {
                console.log(res);

                res.data.map((item) => {
                    that.chartOption.xAxis.data.push(item.price_date);
                    that.chartOption.series[0].data.push(item.min_price);
                    that.chartOption.series[1].data.push(
                        item.max_price - item.min_price
                    );
                    that.chartOption.series[2].data.push(item.avg_price);
                });
                // console.log(that.chartOption.series)
                that.chart.setOption(that.chartOption);
            });
        },
        changeQuery(type = "", date = "") {
            this.curType = type == "" ? this.curType : type;
            this.curDate = date == "" ? this.curDate : date;
            const year = new Date().getFullYear();
            const mouth = new Date().getMonth() + 1;
            if (type == "year") {
                this.queryChart.mouth = "";
                this.queryChart.year = date == "prev" ? year - 1 : year;
            }
            if (type == "mouth") {
                this.queryChart.year = year;
                this.queryChart.mouth = date == "prev" ? mouth - 1 : mouth;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/ .swiper {
    .el-carousel__indicators--horizontal {
        left: 360px;
        bottom: 15%;
    }
}
.production {
    @include body-padding();
    padding: {
        top: 64px;
        bottom: 64px;
    }
    .list {
        .list-item {
            background-color: #ffffff;
            border-radius: 4px;
            padding: 32px 0;
            display: flex;
            align-items: center;
            .left {
                text-align: center;
                width: 360px;
                font-weight: 600;
                .area {
                    font-size: $font-size-l;
                    color: $color-title;
                }
                .state {
                    color: $color-main;
                }
            }
            .main {
                width: 840px;
                padding: 0 48px;
                border-left: 1px dashed #d9d9d9;
            }
            &:hover {
                border-left: 6px solid $color-main;
                box-shadow: 0px 6px 9px 1px rgba(1, 152, 69, 0.1);
            }
        }
        .list-item + .list-item {
            margin-top: 12px;
        }
    }
}
.sales {
    background-color: #f5f5f5;
    @include body-padding();
    padding: {
        top: 40px;
        bottom: 48px;
    }
    .el-pagination {
        margin-top: 32px;
        text-align: end;
    }
}
.report {
    @include body-padding();
    padding: {
        top: 64px;
        bottom: 64px;
    }
    .el-col {
        position: relative;
        height: 220px;
        overflow: hidden;

        .text {
            position: absolute;
            top: 49px;
            left: calc(204px - 165px);
            width: 330px;
            height: 123px;
            padding: 20px 35px;
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.4);

            .month,
            .year,
            .name {
                color: #fff;
            }
            .month {
                flex-basis: 100%;
                font-size: 22px;
                font-weight: 600;
            }
            .year {
                flex-basis: 50%;
                font-size: $font-size-l;
            }
            .name {
                flex-basis: 100%;
                font-size: 32px;
                font-weight: 600;
            }
        }
    }
}
.data {
    @include body-padding();
    background-color: #f5f5f5;
    padding: {
        top: 40px;
        bottom: 104px;
    }
    .title {
        color: $color-title;
        font-size: $font-size-m;
        margin-bottom: 20px;
        font-weight: 600;
    }
    .price-tag {
        width: 188px;
        height: 91px;
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 12px;
        cursor: pointer;
        .province {
            font-weight: 600;
            color: $color-title;
        }
        .price {
            font-size: $font-size-m;
            font-weight: 600;
            color: $color-title;
        }
        .date {
            font-size: $font-size-s;
        }
    }
    .el-pagination {
        position: absolute;
        bottom: 0;
    }
    .filter {
        display: flex;
        justify-content: space-between;
        .el-input__inner {
            background-color: rgba(0, 0, 0, 0.2);
            color: $color-main;
        }
        .el-range-editor.is-active,
        .el-range-editor.is-active:hover,
        .el-select
            .el-input__inner:focus，
            .el-select
            .el-input.is-focus
            .el-input__inner {
            border-color: $color-main;
        }
    }
    .granularity {
        display: flex;
        justify-content: space-around;
        color: $color-main;
        margin-top: -28px;
        z-index: 9;
        position: relative;

        .tab-date {
            display: flex;
            justify-content: space-between;
            div {
                margin: 0 10px;
                cursor: pointer;
            }

            .active {
                font-weight: 600;
                border-bottom: $color-main solid 2px;
            }
        }
    }
}
/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select.el-input__inner:focus，
    .el-select.el-input.is-focus.el-input__inner {
    border-color: $color-main;
}
.el-select-dropdown__item.selected {
    color: $color-main;
}
</style>



// WEBPACK FOOTER //
// src/pages/quotation/index.vue